import { render, staticRenderFns } from "./MenuPanel.vue?vue&type=template&id=b25d452c&scoped=true&"
import script from "./MenuPanel.vue?vue&type=script&lang=js&"
export * from "./MenuPanel.vue?vue&type=script&lang=js&"
import style0 from "./MenuPanel.vue?vue&type=style&index=0&id=b25d452c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25d452c",
  null
  
)

export default component.exports